module.exports = __webpack_public_path__ + "media/images/favicon-533878139d5790f2dcb60f841a90ec38.png";